const customDataSourceType = {
    firds: 'firds',
    leiLevel1: 'leiLevel1',
    exchangeRates: 'exchangeRates'
};

export default customDataSourceType;
